// Copyright 2016 Sorama B.V.

import { Unit, LogarithmicUnit, UnitType } from "units/Unit";

export class Generic extends UnitType {
    public static override typeName = "";

    public static milliUnitless: Unit = new Unit("m", 1e-3, Generic, undefined, true);
    public static unitless: Unit = new Unit("", 1, Generic, undefined, true);
    public static kiloUnitless: Unit = new Unit("k", 1e3, Generic, undefined, true);
    public static megaUnitless: Unit = new Unit("M", 1e6, Generic, undefined, true);

    public static logUnitless: LogarithmicUnit = new LogarithmicUnit("", 10, 1, Generic, undefined, true);
}
